module.exports = __webpack_public_path__ + "media/front-desk-bells-daniel_simon.7cab8455.mp3";